import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsCustomerServiceManagementFeedbackRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/projectSettingsCustomerServiceManagementFeedbackRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { APP_NAMES, toPackageName } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { serviceDeskFeedbackSettingsEntrypoint } from '@jira/spa-apps__project-settings-service-desk-feedback-settings/src/serviceDeskFeedbackSettingsEntrypoint.entrypoint.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';

const projectSettingsCustomerServiceManagementFeedbackPageEntrypoint = createPageEntryPoint({
	main: serviceDeskFeedbackSettingsEntrypoint,
});

export const projectSettingsCustomerServiceManagementFeedbackRouteEntry: Route = createEntry(
	projectSettingsCustomerServiceManagementFeedbackRoute,
	() => ({
		group: 'project-settings-customer-service',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		entryPoint: () =>
			fg('csm_appification_standalone_navigation')
				? projectSettingsCustomerServiceManagementFeedbackPageEntrypoint
				: notFoundPageEntrypoint,
		resources: [...getServiceDeskSettingsResources(), getConsolidationStateResource()],
		forPaint: [LazyAtlassianNavigation],
		perfMetricKey: 'jsm-feedback-settings',
		meta: {
			reporting: {
				id: APP_NAMES.CSAT_CONFIG,
				packageName: toPackageName(APP_NAMES.CSAT_CONFIG),
				teamName: 'jsm-request-intake',
			},
		},
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
